/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expenseCategories/furniture': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M20.967 9.778c-1.096 0-1.992 1-1.992 2.222v3.333H5.025V12c0-1.222-.896-2.222-1.992-2.222S1.04 10.778 1.04 12v5.556c0 1.222.897 2.222 1.993 2.222h17.934c1.096 0 1.993-1 1.993-2.222V12c0-1.222-.897-2.222-1.993-2.222zm-2.989-5.556H6.022c-1.096 0-1.993 1-1.993 2.222v2.39c1.156.455 1.993 1.677 1.993 3.133v2.255h11.956v-2.255c0-1.445.837-2.667 1.993-3.134V6.444c0-1.222-.897-2.222-1.993-2.222z" _fill="#000" fill-rule="evenodd"/>'
  }
})
